import React from "react";

interface Props {
  onTryAgain: () => void
}

const ErrorTryAgainLabel = (props: Props) => {
  return <div onClick={props.onTryAgain}>
    <div>{RESX.GeneralLabels.SomethingUnexpectedHappened}</div>
  </div>;
};

export default ErrorTryAgainLabel;